// extracted by extract-css-chunks-webpack-plugin
module.exports = {"iframe":"_1huihk","ready":"_1HNSJg"};